export const GLOBAL_OVERLAYS_TARGET = 'global_overlays';
